import { render, staticRenderFns } from "./MyRightsSetupView.vue?vue&type=template&id=20d7b138&scoped=true&"
import script from "./MyRightsSetupView.vue?vue&type=script&lang=ts&"
export * from "./MyRightsSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7b138",
  null
  
)

export default component.exports